import { PrismicNextLink } from "@prismicio/next";
import { PrismicRichText as BasePrismicRichText } from "@prismicio/react";

import { Heading } from "./Heading";

/** @type {import("@prismicio/react").JSXMapSerializer} */
const defaultComponents = {
  heading1: ({ children }) => (
    <Heading as="h1" size="5xl" className="mb-7 mt-12 first:mt-0 last:mb-0">
      {children}
    </Heading>
  ),
  heading2: ({ children }) => (
    <Heading as="h2" size="4xl" className="mb-7 last:mb-0 tracking-loose">
      {children}
    </Heading>
  ),
  heading3: ({ children }) => (
    <Heading as="h3" size="3xl" className="mb-7 last:mb-0">
      {children}
    </Heading>
  ),
  paragraph: ({ children }) => (
    <p className="font-sans text-base mb-7 last:mb-0 font-normal leading-relaxed">
      {children}
    </p>
  ),
  oList: ({ children }) => (
    <ol className="font-sans text-base mb-7 pl-4 last:mb-0 md:pl-6">
      {children}
    </ol>
  ),
  oListItem: ({ children }) => (
    <li className="font-sans text-base mb-1 list-decimal pl-1 last:mb-0 md:pl-2">
      {children}
    </li>
  ),
  list: ({ children }) => (
    <ul className="font-sans text-base mb-7 pl-4 last:mb-0 md:pl-6">
      {children}
    </ul>
  ),
  listItem: ({ children }) => (
    <li className="font-sans text-base mb-1 list-disc pl-1 last:mb-0 md:pl-2">
      {children}
    </li>
  ),
  preformatted: ({ children }) => (
    <pre className="mb-7 rounded bg-slate-100 p-4 text-sm last:mb-0 md:p-8 md:text-lg">
      <code>{children}</code>
    </pre>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
  hyperlink: ({ children, node }) => (
    <PrismicNextLink
      field={node.data}
      className="underline decoration-1 underline-offset-2 text-blue-500"
    >
      {children}
    </PrismicNextLink>
  ),
};

export function PrismicRichText({ components, ...props }) {
  return (
    <BasePrismicRichText
      components={{ ...defaultComponents, ...components }}
      {...props}
    />
  );
}
